<template lang="html">

  <section class="wrapper home">

    <section class="cuadro-intro row-center">

      <h1>Comienza tu búsqueda</h1>

    </section>

    <section class="home-wrapper container">


      <buscador></buscador>


      <div class="bottom">

        <nav class="breadcrumb">
          <router-link :to="$t('enlaces.home')">Inicio</router-link>
        </nav>

        <div class="contenedor-ofertas" v-if="!!ofertas">

          <h3>Ofertas destacadas</h3>

          <section class="listado-ofertas" v-if="!!ofertas">

            <oferta :data="oferta" :key="key" v-for="(oferta, key) in ofertas.slice(0,2)"></oferta>

          </section>

          <router-link class="btn skull" :to="$t('enlaces.ofertas')">Ver todas</router-link>

        </div>

        <div class="links-container row-center ais">

          <article class="link-el column-between">

            <div>

              

              <img src="@/assets/img/link-candidaturas.jpg" alt="Enlace a mis candidaturas">

              <p>Revisa las ofertas a las que te has inscrito así como aquellas para las cuales hemos considerado tu
                perfil desde ESIC. Conoce el estado de tus candidaturas.</p>

            </div>

            <router-link :to="$t('enlaces.miscandidaturas')" class="btn skull">Ver mis candidaturas</router-link>

            <router-link :to="$t('enlaces.miscandidaturas')" class="enlace-cover"></router-link>

          </article>

          <article class="link-el column-between">

            <div>


              <img src="@/assets/img/link-mi-cv.jpg" alt="Enlace a mis candidaturas">

              <p>Durante toda tu trayectoria profesional, ponemos a tu disposición oportunidades de empresas,
                consultoras
                de selección y headhunters de referencia a nivel internacional. Actualiza ya tu perfil.</p>

            </div>

            <router-link :to="$t('enlaces.micv')" class="btn skull">Ver mi currículum</router-link>

            <router-link :to="$t('enlaces.micv')" class="enlace-cover"></router-link>

          </article>

        </div>

      </div>

    </section>

  </section>

</template>

<script lang="js">

  import oferta from '@/components/parts/oferta-el';

  import buscador from '@/components/parts/buscador-home';

  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'home',
    mounted() {

      if(this.ofertas == null){
        this.requestOfertasDestacadas();
      }
      
    },
    data() {
      return {
        
      }
    },
    components: {
      oferta,
      buscador
    },
    methods: {
      ...mapActions(['requestFirstsOfertas','requestOfertasDestacadas']),
    },
    computed: {
      ...mapGetters({
        ofertas: 'getOfertasDestacadas'
      })
    }
  }
</script>

<style scoped lang="scss">

  .loading{
    height: 100px;
    background-size: auto 170px, auto 15px;
  }

</style>


// WEBPACK FOOTER //
// src/components/views/home.vue